<template>
    <Modal
        v-model="show"
        :width="modalWidth"
        class="modal-class"
    >
        <Collapse value="1" style="margin-top: 30px">
            <Panel name="1">&nbsp;&nbsp;<b>{{formData.dialogTitle}}</b>&nbsp;<Icon
                type="search"></Icon>
                <!-- showHeader参数为是否显示搜索头 -->
                <div slot="content" v-if="!formData.showHeader">
                    <Form :model="formData" label-position="right" class="bill-form" @submit.native.prevent
                          ref="formData">
                        <Row :gutter="0">
                            <Col span="8">
                                <FormItem label="搜索条件" :label-width="formData.labelWidth" prop="searchValue">
                                    <Select v-model="formData.searchValue" placeholder="">
                                        <Option v-for="item in formData.searchList" :value="item.value"
                                                :key="item.label">{{
                                            item.label }}
                                        </Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col span="5" offset="1">
                              <!-- dateType参数为增加日期选择 -->
                                <FormItem label="" prop="inputValue">
                                    <DatePicker
                                      v-model="formData.inputValue"
                                      value-format="yyyy-MM-dd"
                                      v-if="formData.dateType && formData.searchValue === '5'"
                                      type="date" placeholder="请选择截止日期"
                                      style="width: 100%"
                                      :options="formData.options"
                                      :clearable="formData.clearable"
                                    >
                                    </DatePicker>
                                    <Input v-else v-model="formData.inputValue" placeholder="" clearable></Input>
                                </FormItem>
                            </Col>
                            <Col span="7" offset="2">
                                <FormItem>
                                    <Button type="primary" style="" @click="handleSearch">搜索</Button>
                                    <Button type="primary" style="margin-left: 10px" @click="handleSelect"
                                            :disabled="getSelectedStatus || !selectionData">
                                        选择
                                    </Button>
                                    <Button type="primary" v-if="$attrs.selcetAll" style="margin-left: 10px" @click="handleAllSelect"
                                            :disabled="getSelectedStatus">
                                        导入全部
                                    </Button>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Panel>
        </Collapse>
        <Table
               v-if="show"
               :columns="tableColumns"
               :data="tableData"
               :loading="loading"
               size="small"
               :highlight-row="highlightRow"
               @on-row-dblclick="onRowDblclick"
               @on-row-click="onRowClick"
               @on-select="onSelect"
               @on-select-all="onSelectAll"
               stripe
               border
        ></Table>
        <div slot="footer">
            <!--<Page :total="totalpages" :page-size="pageSize" :current="currentPage"-->
                  <!--@on-change="onPageChange" @on-page-size-change="onPageSizeChange"-->
                  <!--show-total show-elevator></Page>-->
            <m-pagination v-if="settings.needPager"
                          :showElevator="settings.showElevator" :showSizer="settings.showSizer"
                          :currentPage="currentPage" :pageSize="pageSize" :total="totalpages"
                          :pageSizeOpts="settings.pageSizeOpts"
                          @on-page-size-change="onPageSizeChange"
                          @on-current-page-change="onPageChange"></m-pagination>
        </div>
    </Modal>
</template>
<script>
    import MPagination from '@/components/awesome/page/pagination/main';

    export default {
        name: 'CustomDate',
        components: {MPagination},
        computed: {
            getSelectedStatus: function () {
                if (this.tableData.length === 0) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        data() {
            return {
                settings: {
                    needValidation: true,
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 30, 50, 80],
                    needSearch: true
                },
                show: false,
                selectionData: {},
            };
        },
        props: {
            // show: {
            //     type: Boolean,
            //     default() {
            //         return false;
            //     }
            // },
            tableColumns: {
                type: Array,
                default() {
                    return [];
                }
            },
            tableData: {
                type: Array,
                default() {
                    return [];
                }
            },
            loading: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            modalWidth: {
                type: Number,
                default() {
                    return 560;
                }
            },
            currentPage: {
                type: Number,
                default() {
                    return 1;
                }
            },
            pageSize: {
                type: Number,
                default() {
                    return 10;
                }
            },
            totalpages: {
                type: Number,
                default() {
                    return 0;
                }
            },
            formData: {
                type: Object,
                default() {
                    return {
                        items: []
                    };
                }
            },
            highlightRow: {
                type: Boolean,
                default() {
                    return false;
                },
            },
        },
        watch: {
            formData() {
                this.data = Object.assign({}, this.formData);
            }
        },
        methods: {
            onPageChange: function (currentPage) {
                this.$emit('on-page-change', currentPage);
            },
            onRowClick(row) {
                this.selectionData = row;
            },
            onRowDblclick(row) {
                this.$emit('onRowDblclick', row);
            },
            onPageSizeChange: function (pageSize) {
                this.$emit('on-page-size-change', pageSize);
            },
            handleSearch: function () {
              console.log(this.formData)
                this.$refs['formData'].validate((valid) => {
                    if (valid) {
                        this.$emit('handleSearch');
                        this.selectionData = null;
                    }
                });
            },
            handleSelect: function () {
                this.$emit('handleSelect', this.selectionData);
            },
            handleAllSelect: function () {
                this.$emit('handleAllSelect');
            },
            onSelect(selection) {
                this.$emit('onSelect', selection);
            },
            onSelectAll(selection) {
                this.$emit('onSelectAll', selection);
            }
        }
    };
</script>
<style lang="less">
    .modal-class {
        .m-modal {
            top: 20px;
        }
        .m-modal-footer{
            text-align: unset;
        }
    }
</style>
